var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('div',{staticClass:"wicon"}),_c('div',{staticClass:"label"},[_vm._v("雷 16℃~20℃")])])
}]

export { render, staticRenderFns }